export default __webpack_public_path__ + "6dc5c7b47882363879bec9fd570e4afa.jpg";